import config from "@/js/config.js";
import footerLinks from "@/js/seoArticles/footer.js";

const projectName = config.projectName;
const description = `AS Live is a current hub where all the sports fans gather for newsfeed. Every aspect of the tournament will be made accessible at all times. When a football match is held, the live scores will be updated in real-time as it progresses.`;
const footerLinksPageMeta = {};
Object.values(footerLinks).forEach((arr) => {
  if (arr.length > 0) {
    arr.forEach((article) => {
      footerLinksPageMeta[article.id] = (route) => ({
        title: article.titleTag,
        description: article.metaDescription,
      });
    });
  }
});

export default {
  home: (route) => ({
    title: `足球實時賽果、實時比分、賽程、精彩鏡頭 - ${projectName}`,
    description: description,
  }),
  highlights: (route) => ({
    title: `足球精彩鏡頭、足球實時賽果、足球精彩鏡頭 - ${projectName}`,
    description: description,
  }),
  news: (route) => ({
    title: `在線觀看足球、足球精彩鏡頭、直播 - ${projectName}`,
    description: description,
  }),
  event: (route) => ({
    title: `足球比賽、足球比賽和活動 - ${projectName}`,
    description: description,
  }),
  account: (route) => ({
    title: `我的個人資料 - ${projectName}`,
    description: description,
  }),
  player: (route) => ({
    title: `${route.params.playerName
      .split("-")
      .join(" ")} 個人資料 - ${projectName}`,
    description: description,
  }),
  matchDetail: (route) => ({
    title: `${route.params.opponent
      .split("-")
      .join(" ")} 精彩鏡頭 - ${projectName}`,
    description: description,
  }),
  highlightsDetail: (route) => ({
    title: `${route.params.opponent
      .split("-")
      .join(" ")} 精彩鏡頭 - ${projectName}`,
    description: description,
  }),
  ...footerLinksPageMeta,
};
